import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { productCategoriesApi } from "api/api/productCategoriesApi/productCategoriesApi";
import i18n from "i18n";
import { toast } from "react-toastify";

export const deleteProductCategoryByCategoryId = createAsyncThunk<void, number>(
  "products/deleteProductCategory",
  async (categoryId, { rejectWithValue }) => {
    const t = i18n.t.bind(i18n);
    try {
      const data = await productCategoriesApi.deleteProductCategoryByCategoryId(categoryId);

      toast.success(String(t("toast.deleteProductCategorySuccess")));

      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while deleting product", error?.response?.data);

        const serverMessage = (error?.response?.data as any)?.message;
        toast.error(serverMessage || t("toast.deleteProductCategoryError"));

        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while deleting product", error);

        toast.error(String(t("toast.unknownProductCategoryError")));

        return rejectWithValue(t("toast.unknownProductError"));
      }
    }
  }
);
